/**
 * «Забыли пароль» — отправка письма со ссылкой на смену пароля.
 * Ответ сервера одинаков независимо от того, есть такой email или нет.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { motion } from 'framer-motion';

import { APIAuthRequestPasswordReset } from '../api_auth';
import {
    AuthBackground, Logo, Field, PrimaryButton, TextLink, Notice, StatusScreen, IconMail,
    IconMailSent,
} from '../components/Auth/ui';

export default function ForgotPasswordPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e?.preventDefault();
        setError(null);
        if (!email.trim()) { setError('Введите email'); return; }
        setLoading(true);
        try {
            await APIAuthRequestPasswordReset(email.trim());
            setSent(true);
        } catch (err) {
            setError(err?.response?.data?.error || 'Не удалось отправить письмо. Попробуйте ещё раз');
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <StatusScreen
                icon={<IconMailSent />}
                title="Письмо отправлено"
                text={`Если ${email.trim()} зарегистрирован, на него придёт ссылка для смены пароля. Загляните в папку «Спам», если письма нет.`}
            >
                <PrimaryButton onClick={() => navigate('/login')}>Вернуться ко входу</PrimaryButton>
            </StatusScreen>
        );
    }

    return (
        <AuthBackground>
            <div className="lv-screen lv-login">
                <motion.div className="lv-login__brand"
                            initial={{ opacity: 0, y: -14 }} animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.45 }}>
                    <Logo size="lg" />
                    <div className="lv-login__name">Забыли пароль?</div>
                    <div className="lv-login__tag">Пришлём ссылку для смены пароля на почту</div>
                </motion.div>

                <motion.form className="lv-panel" onSubmit={submit} noValidate
                             initial={{ opacity: 0, y: 26, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
                             transition={{ delay: 0.12, type: 'spring', stiffness: 260, damping: 26 }}>
                    {error ? <Notice tone="error">{error}</Notice> : null}

                    <Field icon={<IconMail />} type="email" inputMode="email" autoComplete="email"
                           placeholder="Email" value={email} autoFocus enterKeyHint="go"
                           onChange={(e) => setEmail(e.target.value)} />

                    <PrimaryButton type="submit" loading={loading}>
                        {loading ? 'Отправляем…' : 'Отправить ссылку'}
                    </PrimaryButton>
                </motion.form>

                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
                            style={{ textAlign: 'center', marginTop: 10 }}>
                    <TextLink onClick={() => navigate('/login')}>Вспомнил пароль — войти</TextLink>
                </motion.div>
            </div>
        </AuthBackground>
    );
}
